import axios from 'axios';
import { setItems, removeItems } from 'helpers/localStorage';
import loginActions from './loginActions';
import { getTimeZone } from '../../helpers/getTimeZone';
import personalProfileActions from 'store/personalProfile/personalProfileActions';
import kioskPageActions from 'store/kiosk/kioskPageActions';
import permissionsActions from 'store/permissions/permissionsActions';
import workerSchedulePageActions from 'store/workerSchedule/workerSchedulePageActions';
import { laborClassificationsActions } from 'store/laborClassifications';

export const saveTokens = (data) =>
  setItems([
    { key: 'authorization-token', value: data.token },
    { key: 'authorization-token-exp-at', value: data.expiresAt },
    { key: 'refresh-token', value: data.refreshToken },
    { key: 'refresh-token-exp-at', value: data.refreshExpiresAt },
  ]);

const signIn = (route, body, navigate) => async (dispatch) => {
  const { data } = await axios.post(`${process.env.REACT_APP_BASE_URL}${route}`, body);
  saveTokens(data);
  dispatch(loginActions.setAuthUser(data));
  navigate('/');
};

export const loginWithPassword = (email, password, navigate) =>
  signIn('/login', { email, password }, navigate);

export const loginWithCode = (phoneNumber, phoneCode, navigate) =>
  signIn('/login/phone/code', { phoneNumber, phoneCode }, navigate);

export const resendEmailChangeLink = (email, password) =>
  axios.post(`${process.env.REACT_APP_BASE_URL}/email-change/resend`, { email, password });

export const logout = () => async (dispatch) => {
  const refreshToken = localStorage.getItem('refresh-token');
  const options = {
    headers: {
      'X-Auth-Token': localStorage.getItem('authorization-token'),
      'X-User-TZ': getTimeZone(),
    },
  };

  try {
    removeItems([
      'authorization-token',
      'authorization-token-exp-at',
      'refresh-token',
      'refresh-token-exp-at',
      'userId',
      'x-auth-kiosk-token',
      'x-admin-kiosk-token'
    ])
    localStorage.setItem('isKioskPage', '0')
    dispatch(kioskPageActions.logout())
    dispatch(permissionsActions.clearPermissions())
    dispatch(kioskPageActions.clearPersonalProfile())
    dispatch(loginActions.clearUserData());
    dispatch(personalProfileActions.clearPersonalProfile());
    dispatch(workerSchedulePageActions.reset());
    dispatch(laborClassificationsActions.reset());

    await axios.post(`${process.env.REACT_APP_BASE_URL}/logout`, { refreshToken }, options);


  } catch (error) {
    console.log('login error');
  }
};